import { Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { Sx } from "utils/sx";
import { EventCard } from "./eventCard/EventCard";
import { EventCardTopLabel } from "./eventCard/EventCardTopLabel";
import { EventCardMainSection } from "./eventCard/EventCardMainSection";
import { EventCardOrganisation } from "./eventCard/EventCardOrganisation";
import { EventCardTitle } from "./eventCard/EventCardTitle";
import { RecentlyViewedRankings } from "./useRecentlyViewed";
import { trackClick, trackingCategory } from "utils/tracking";

export const RecentlyViewedRankingsCard: React.FC<{
    item: RecentlyViewedRankings;
    sx?: Sx;
}> = ({ item, sx }) => {
    return (
        <Link
            to={`/${item.data.organisation.shortName}/rankings?series=${item.data.seriesId}&division=${item.data.divisionId}`}
            aria-label={`${item.data.divisionName} - ${item.data.seriesName}`}
            onClick={trackClick(
                "Ranking card",
                trackingCategory.recentlyViewed,
            )}
        >
            <EventCard sx={sx}>
                <EventCardMainSection sx={{ flex: 1 }}>
                    <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <EventCardTopLabel date="Rankings" />
                    </Stack>
                    <EventCardTitle
                        title={`${item.data.divisionName} - ${item.data.seriesName}`}
                    />
                </EventCardMainSection>
                <EventCardOrganisation
                    organisation={item.data.organisation}
                    logo={true}
                />
            </EventCard>
        </Link>
    );
};
